export default "__VITE_ASSET__D8yLns42__"